export default "__VITE_ASSET__1QTqtnKu__"